import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../components/typography';
import Card from '../../icons/williamhill/card';
import { Or, VerticalLine } from '../components';
import SwipeCard from '../swipe-card';

export default function Pos() {
  return (
    <Container>
      <Text size="lg" weight="bold" style={{ width: '24.6rem' }}>
        Swipe the customer's rewards card in the reader.
      </Text>
      <Or />
      <Text size="lg" weight="bold" style={{ width: '22.9rem' }}>
        Enter the number shown on the customer's rewards card.
      </Text>

      <SwipeCard />
      <VerticalLine />
      <Card />
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  padding: 3rem 11rem;
  width: 80.2rem;
  gap: 3rem;
  grid-template-columns: 1fr 32px 1fr;
  grid-template-rows: 7rem auto;
  justify-items: center;
`;
